import { render, staticRenderFns } from "./LoanSettlement.vue?vue&type=template&id=51b15580&v-if=loanDetailsForm&"
import script from "./LoanSettlement.vue?vue&type=script&lang=js&"
export * from "./LoanSettlement.vue?vue&type=script&lang=js&"
import style0 from "./LoanSettlement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoanDetailsAssetDialog: require('/codebuild/output/src195787613/src/cc-portal/components/LoanDetailsAssetDialog.vue').default,LenderDialog: require('/codebuild/output/src195787613/src/cc-portal/components/LenderDialog.vue').default,CpdSendConfirmDialog: require('/codebuild/output/src195787613/src/cc-portal/components/CpdSendConfirmDialog.vue').default})
